export type RequiredAddressFields = {
  street: string
  city: string
  state: string
  postal: string
  country: string
}

export type Address = RequiredAddressFields & {
  refinement: string
}

export type AutoCompleteAddressResult = Address & {
  entries: number
}

export type AutoCompleteResults = AutoCompleteAddressResult[]

// The autocomplete API is US address only
export const buildAutocompleteQuery = (obj: Omit<Address, 'country'>): string =>
  Object.values(obj)
    .reduce(
      (acc, val) =>
        typeof val === 'string' && val.trim().length === 0
          ? acc
          : [...acc, val],
      []
    )
    .join('&')
